// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-section[data-v-f9f9e5e6]{margin:10px 0}.img[data-v-f9f9e5e6]{display:block;width:100%}.bg-gray[data-v-f9f9e5e6]{background-color:#eee;height:20px;width:100%}.mh-10[data-v-f9f9e5e6]{margin-left:10px;margin-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
